import { ElementRef, Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, shareReplay } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CategoryTabPayload } from '../interfaces/homepage.interfaces';
import { HomepageCacheService } from '../services-cache/homepage-cache.service';

@Injectable({
  providedIn: 'root'
})
export class ArtistsService {

  private api_base_url = environment.api_base_url;

  constructor(
    private http: HttpClient,
    private cache: HomepageCacheService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ){}

  getArtists(payload: CategoryTabPayload | {}): Observable<any> {
    const path = `${this.api_base_url}/api/location-artist-management/event-artists`;
    const headers = new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' });
    return this.http.post(path, payload, { headers }).pipe(
      shareReplay(1)
    );
  }

  getArtistDetails(slug: string): Observable<any> {
    const path = `${this.api_base_url}/api/artists/${slug}/details`;
    const headers = new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' });
    return this.http.get(path, { headers }).pipe(
      shareReplay(1)
    );
  }

  followArtist(artistId: string): Observable<any> {
    const path = `${this.api_base_url}/api/artists/follow/${artistId}`;
    const headers = new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' });
    return this.http.post(path, { headers });
  }

  unfollowArtist(artistId: string): Observable<any> {
    const path = `${this.api_base_url}/api/artists/unfollow/${artistId}`;
    const headers = new HttpHeaders({ 'X-Requested-With': 'XMLHttpRequest' });
    return this.http.post(path, { headers });
  }

}
